import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultContactInfo,
  defaultCosts,
  useManualAndInternationalAddress,
  useRentPriceTypeCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantStoreRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    price: useRentPriceTypeCondition,
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    separableSpace: validationRules.separableSpace,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
  },
  costs: defaultCosts,
  description: {
    adTitle: validationRules.adTitle,
    adDescription: validationRules.adDescription,
    adLocation: validationRules.adLocation,
  },
  otherFacilities: {
    frontWindowLength: validationRules.frontWindowLength,
    floorLoad: validationRules.floorLoad,
    totalFloorsNumber: validationRules.totalFloors,
    goodsLiftLoad: validationRules.loadLiftingValue,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  contactInfo: defaultContactInfo,
  connections: defaultConnections,
}
